module.exports = __webpack_public_path__ + "static/media/fox.287e3549.png";